import React from "react";
import { useTranslation } from "react-i18next";
import HeroCardLayout from "../layout/HeroCardLayout";
import "../../styles/components/entryflow/Selector.css";

interface Props {
  caption?: string;
  onContinue: () => void;
}

const SelectorStartView: React.FC<Props> = ({ caption, onContinue }) => {
  const { t } = useTranslation();
  
  const handleContinue = (e: React.FormEvent) => {
    e.preventDefault();
    onContinue();
  };

  return (
    <div className="selector-start-container">
      {caption && <div className="selector-start-caption">{caption}</div>}
      <button className="entryflow-submit-button selector-continue-button" onClick={handleContinue}>
        {t("selector.start")}
      </button>
    </div>
  );
};

const SelectorStartViewOnlyComponent: React.FC = () => {
  return (
    <HeroCardLayout>
      <SelectorStartView 
        caption={"To speak with Anatoly, we need to collect some information first."} 
        onContinue={() => {}} 
      />
    </HeroCardLayout>
  );
};

export default SelectorStartView;
export { SelectorStartViewOnlyComponent };
